import { useMemo } from "react";

import { FlowTypes } from "config/types";

export const useFlowFieldTitles = (slug: FlowTypes) => {
  const fieldTitles = useMemo(() => {
    switch (slug) {
      default:
        return {};
    }
  }, [slug]);

  return fieldTitles;
};
